import React from 'react';
const fallbackMemory = {};
const isBrowser = typeof window !== 'undefined';
const fallbackStorage = {
    getItem(key) {
        return fallbackMemory[key];
    },
    setItem(key, value) {
        fallbackMemory[key] = value;
    },
};
class StorageAdaptor {
    constructor(prefix) {
        if (isBrowser) {
            this.storage = window.sessionStorage || fallbackStorage;
        }
        else {
            this.storage = fallbackStorage;
        }
        this.prefix = prefix;
    }
    getStorageKey(key) {
        return this.prefix ? `${this.prefix}-${key}` : key;
    }
    getItem(key) {
        return this.storage.getItem(this.getStorageKey(key));
    }
    setItem(key, value) {
        this.storage.setItem(this.getStorageKey(key), value);
    }
}
export const useStorage = (prefix) => {
    const storage = React.useMemo(() => {
        return new StorageAdaptor(prefix);
    }, [prefix]);
    return storage;
};
